import React, { useState } from "react";
import { Styles } from "../award-event/styles/awardEvent";
import Header from "../../components/Header";
import { BreadcrumbBox } from "../../components/common/Breadcrumb";
import { Col, Container, Row } from "react-bootstrap";
import Footer from "../../components/Footer";
import "./styles/event-common.css";

const Event16 = () => {
  return (
    <Styles>
      {/* Main Wrapper */}
      <div className="main-wrapper event-page">
        {/* Header 2 */}
        <Header />

        {/* Breadcroumb */}
        <BreadcrumbBox title="Event" img="16_5.jpeg" />
        <Container>
          <Row>
            <Col>
              <a
                href="/news"
                style={{
                  fontSize: "14px",
                  fontWeight: "bold",
                  textDecoration: "underline",
                  lineHeight: "40px",
                }}
              >
                Back To News
              </a>
            </Col>
          </Row>
        </Container>

        {/* News Area */}
        <section className="award-page">
          <Container>
            <Row>
              <Col md="12">
                <div style={{ padding: "20px 0" }}>
                  <h2
                    style={{
                      width: "100%",
                      textAlign: "center",
                      color: "black",
                    }}
                  >
                    Capacity Enhancement Workshop for Municipality officials
                  </h2>

                  <p
                    style={{
                      width: "100%",
                      textAlign: "center",
                      fontSize: "14px",
                      fontWeight: 500,
                      padding: "20px 0",
                    }}
                  >
                    Date: 08–11 November 2025 Location: Dream Square Resort,
                    Gazipur
                  </p>

                  <p
                    style={{
                      width: "100%",
                      textAlign: "justify",
                      fontSize: "16px",
                      color: "black",
                      padding: "20px 0",
                    }}
                  >
                    The CWIS-FSM Support Cell, in collaboration with WaterAid
                    Bangladesh and SNV, successfully conducted a four-day
                    <strong>Capacity Enhancement Workshop</strong> for municipal officials
                    representing 25 municipalities across Bangladesh. The event
                    was organized under the <strong>WASH Systems for Health (WS4H)</strong>
                    project, funded by <strong>UK International Development from the UK
                    Government.</strong>
                  </p>

                  <p
                    style={{
                      width: "100%",
                      textAlign: "justify",
                      fontSize: "16px",
                      color: "black",
                      padding: "10px 0",
                    }}
                  >
                    The workshop aimed to strengthen the technical and
                    institutional capacity of municipal authorities to improve
                    urban sanitation governance. Key focus areas included the
                    application of the <strong>Shit Flow Diagram (SFD)</strong> and <strong>Waste Flow
                    Diagram (WFD)</strong> tools, understanding the <strong>Municipal Act 2009,</strong>
                    and developing effective <strong>sanitation by-laws</strong> to guide
                    citywide sanitation management.
                  </p>

                  <h3>Opening Ceremony</h3>
                  <p style={{
                      width: "100%",
                      textAlign: "justify",
                      fontSize: "16px",
                      color: "black",
                      padding: "10px 0",
                    }}>The workshop was inaugurated in the presence of:</p>
                  <ul>
                    <li style={{
                      width: "100%",
                      textAlign: "justify",
                      fontSize: "16px",
                      color: "black",
                      padding: "10px 0",
                    }}>
                      <strong>Md. Shafiqul Hassan,</strong> Project Director, Chattogram Hill
                      Tracts Inclusive and Resilient Urban Water Supply and
                      Sanitation Project, and Co-Chair of the CWIS-FSM Support
                      Cell
                    </li>
                    <li style={{
                      width: "100%",
                      textAlign: "justify",
                      fontSize: "16px",
                      color: "black",
                      padding: "10px 0",
                    }}>
                      <strong>Dr. Abdullah-al-Muyeed,</strong> Chief Operating Officer, CWIS-FSM
                      Support Cell, DPHE, Bangladesh
                    </li>
                  </ul>
                  <p style={{
                      width: "100%",
                      textAlign: "justify",
                      fontSize: "16px",
                      color: "black",
                      padding: "10px 0",
                    }}> 
                    Both emphasized the importance of strengthening municipal
                    systems and governance structures to achieve long-term,
                    citywide inclusive sanitation outcomes.
                  </p>

                  <h3>Highlights of the Workshop</h3>
                  <p style={{
                      width: "100%",
                      textAlign: "justify",
                      fontSize: "16px",
                      color: "black",
                      padding: "10px 0",
                    }}>Throughout the four days, participants engaged in technical and thematic sessions facilitated by
experts from the CWIS-FSM Support Cell and WaterAid Bangladesh.</p>
                  <ul>
                    <li style={{
                      width: "100%",
                      textAlign: "justify",
                      fontSize: "16px",
                      color: "black",
                      padding: "10px 0",
                    }}>
                      <strong>Md. Tawhidur Rahaman,</strong> Technical Expert, CWIS-FSM Support Cell, delivered
sessions on <strong>Shit Flow Diagram (SFD)</strong> and <strong>Waste Flow Diagram (WFD)</strong>
methodologies, demonstrating how these tools support data-driven decision-making,
monitoring, and planning for improved sanitation and waste management in
municipalities.
                    </li>
                    <li style={{
                      width: "100%",
                      textAlign: "justify",
                      fontSize: "16px",
                      color: "black",
                      padding: "10px 0",
                    }}>
                      <strong>Mr. Sanjoy Mukherjee,</strong> Social Development Expert, CWIS-FSM Support Cell,
conducted sessions on <strong>Citywide Inclusive Sanitation (CWIS) </strong>with special emphasis on

the <strong>accountability pillar,</strong> the <strong>Municipalities Act 2009,</strong> and the process of preparing
<strong>sanitation by-laws.</strong>
                    </li>
                    <li style={{
                      width: "100%",
                      textAlign: "justify",
                      fontSize: "16px",
                      color: "black",
                      padding: "10px 0",
                    }}><strong>WaterAid Bangladesh</strong> facilitated a comprehensive session on <strong>formulating sanitation
by-laws,</strong> providing municipalities with practical guidance for strengthening regulatory
frameworks aligned with national policies.</li>
                  </ul>
                  <h3>Outcome and Way Forward</h3>
                  <p
                    style={{
                      width: "100%",
                      textAlign: "justify",
                      fontSize: "16px",
                      color: "black",
                      padding: "10px 0",
                    }}
                  >
                    <br />
                    The workshop enhanced the knowledge and skills of municipal officials, enabling them to better
plan, manage, and monitor sanitation services in their respective cities. Participants expressed
their commitment to applying the tools and learnings to improve sanitation governance, promote
accountability, and ensure sustainable urban WASH service delivery.
                  </p>

                  <p
                    style={{
                      width: "100%",
                      textAlign: "justify",
                      fontSize: "16px",
                      color: "black",
                      padding: "10px 0",
                    }}
                  >
                    <br />
                    The CWIS-FSM Support Cell, WaterAid Bangladesh, and SNV reaffirmed their commitment to
supporting municipalities across Bangladesh in building resilient, inclusive, and efficient
sanitation systems.
                  </p>
                  <Row>
                    <Col>
                      <div
                        style={{
                          width: "100%",
                          display: "flex",
                          justifyContent: "center",
                        }}
                      >
                        <img
                          style={{
                            width: "100%",
                            maxHeight: "550px",
                            height: "550px",
                            objectFit: "contain",
                          }}
                          src={
                            process.env.PUBLIC_URL +
                            `/assets/images/news26/1.jpeg`
                          }
                          alt="thumb"
                        />
                      </div>
                    </Col>
                    <Col>
                      <div
                        style={{
                          width: "100%",
                          display: "flex",
                          justifyContent: "center",
                        }}
                      >
                        <img
                          style={{
                            width: "100%",
                            maxHeight: "550px",
                            height: "550px",
                            objectFit: "contain",
                          }}
                          src={
                            process.env.PUBLIC_URL +
                            `/assets/images/news26/2.jpeg`
                          }
                          alt="thumb"
                        />
                      </div>
                    </Col>
                  </Row>

                  <br />
                </div>
              </Col>
            </Row>
          </Container>
        </section>
        <Footer />
      </div>
    </Styles>
  );
};

export default Event16;
